namespace SorAraBul.Administration {
    export class UserColumns {
        static columnsKey = 'Administration.User';
    }
}
